import React from "react";
import { Line, Bar } from "react-chartjs-2";
import "chart.js/auto"; // required

// ----- MUI -----
import { Grid, Card, CardContent, Typography } from "@mui/material";

// ----- SAMPLE DATA -----
const sampleKeycutData = [
  { date: "2025-02-18", keycount: 42 },
  { date: "2025-02-19", keycount: 55 },
  { date: "2025-02-20", keycount: 38 },
  { date: "2025-02-21", keycount: 61 },
  { date: "2025-02-22", keycount: 47 },
  { date: "2025-02-23", keycount: 53 },
  { date: "2025-02-24", keycount: 49 }
];

const sampleEnergyData = [
  { date: "2025-02-18", energy: 1200 },
  { date: "2025-02-19", energy: 1350 },
  { date: "2025-02-20", energy: 1100 },
  { date: "2025-02-21", energy: 1500 },
  { date: "2025-02-22", energy: 1250 },
  { date: "2025-02-23", energy: 1450 },
  { date: "2025-02-24", energy: 1320 }
];

// ----- CHART DATA -----
const keycutChartData = {
  labels: sampleKeycutData.map(d => d.date),
  datasets: [
    {
      label: "Total Key Cut",
      data: sampleKeycutData.map(d => d.keycount),
      borderColor: "rgb(255, 99, 132)",
      backgroundColor: "rgba(255, 99, 132, 0.5)"
    }
  ]
};

const energyChartData = {
  labels: sampleEnergyData.map(d => d.date),
  datasets: [
    {
      label: "Energy",
      data: sampleEnergyData.map(d => d.energy),
      backgroundColor: "rgba(54, 162, 235, 0.5)",
      borderColor: "rgb(54, 162, 235)"
    }
  ]
};

const options = {
  responsive: true,
  plugins: {
    legend: { position: "top" }
  }
};

// ----- COMPONENT -----
export default function SampleGridCharts() {
  return (
    <Grid container spacing={3} >

      {/* 1st Graph */}
      <Grid item xs={12} md={6}>
        <Card style={{
              borderRadius: '10px',
            }}>
          <CardContent>
            {/* <Typography variant="h6" gutterBottom>
              Key Cut Chart
            </Typography> */}
            <Line data={keycutChartData} options={options} />
          </CardContent>
        </Card>
      </Grid>

      {/* 2nd Graph */}
      <Grid item xs={12} md={6}>
        <Card style={{
              borderRadius: '10px',
            }}>
          <CardContent>
            {/* <Typography variant="h6" gutterBottom>
              Energy Chart
            </Typography> */}
            <Bar data={energyChartData} options={options} />
          </CardContent>
        </Card>
      </Grid>

    </Grid>
  );
}
